<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-title">
                            Gerenciar Checklists
                            <span class="required_fields">
                                <span class="required">*</span>
                                Campos obrigatórios
                            </span>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12">
                                <form action="">
                                    <div class="card-subtitle mt-2 mb-2">
                                        Solicitação de Imagens
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4 mb-3">
                                            <div class="custom-control custom-switch">
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    id="back_photo_input"
                                                    v-model="category.back_photo"
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    for="back_photo_input"
                                                >
                                                    <span class="ml-3">Imagem Traseira</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="custom-control custom-switch">
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    id="left_side_photo_input"
                                                    v-model="category.left_side_photo"
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    for="left_side_photo_input"
                                                >
                                                    <span class="ml-3">Imagem Lateral Esquerda</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="custom-control custom-switch">
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    id="ceiling_photo_input"
                                                    v-model="category.ceiling_photo"
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    for="ceiling_photo_input"
                                                >
                                                    <span class="ml-3">Imagem Teto</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="custom-control custom-switch">
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    id="right_side_photo_input"
                                                    v-model="category.right_side_photo"
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    for="right_side_photo_input"
                                                >
                                                    <div class="ml-3">Imagem Lateral Direita</div>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="custom-control custom-switch">
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    id="front_photo_input"
                                                    v-model="category.front_photo"
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    for="front_photo_input"
                                                >
                                                    <div class="ml-3">Imagem Frontal</div>
                                                </label>
                                            </div>
                                        </div>

                                        <div class="col-md-4 mb-3 text-right">
                                            <a
                                                class="btn btn-add"
                                                @click="save"
                                            >
                                                Salvar
                                                <i class="fa fa-save ml-2"></i>
                                            </a>
                                        </div>
                                    </div>

                                    <div class="card-subtitle mt-2 mb-2">
                                        <span class="required">*</span>
                                        Tipos de Avaria
                                    </div>
                                    <div class="row">
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <label for="catDmg">Novo Tipo de Avaria</label>
                                                <input
                                                    type="text"
                                                    v-model="breakdown_type.description"
                                                    class="form-control"
                                                    placeholder=""
                                                />
                                            </div>
                                        </div>
                                        <div class="col-md-2 mt-auto mb-4">
                                            <button
                                                type="button"
                                                class="btn btn-add btn-block mt-4"
                                                @click="save_breakdown_type"
                                            >
                                                Cadastrar Novo
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div
                                            :key="b.id"
                                            v-for="(b, indexs) in breakdown_types"
                                            class="col-md-4"
                                        >
                                            <div class="car-add">
                                                <div class="add-type">{{ b.description }}</div>
                                                <div class="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        class="custom-control-input"
                                                        :id="b.id + 'b'"
                                                        v-model="b.status"
                                                        :value="b.id"
                                                        @change="editBreakdownType(b)"
                                                    />
                                                    <a @click="modalEditBreakdown(indexs)">
                                                        <i
                                                            class="far fa-edit"
                                                            style="padding-right: 50px"
                                                        ></i>
                                                    </a>
                                                    <label
                                                        class="custom-control-label"
                                                        :for="b.id + 'b'"
                                                    ></label>
                                                </div>
                                                <div class="clearfix"></div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card-subtitle mt-5 mb-2">
                                        <span class="required">*</span>
                                        Adicionais Para a Check-List
                                    </div>
                                    <div class="row">
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <label for="catAdd">Novo Item Adicional</label>
                                                <input
                                                    type="text"
                                                    v-model="checklist_item.description"
                                                    class="form-control"
                                                    id="catAdd"
                                                    placeholder=""
                                                />
                                            </div>
                                        </div>
                                        <div class="col-md-2 mt-auto mb-4">
                                            <button
                                                type="button"
                                                class="btn btn-add btn-block mt-4"
                                                @click="save_checklist_item"
                                            >
                                                Cadastrar Novo
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div
                                            :key="c.id"
                                            v-for="(c, index) in checklist_items"
                                            class="col-md-4"
                                        >
                                            <div class="car-add">
                                                <div class="add-type">{{
                                                        c && c.description ? c.description : ''
                                                                      }}
                                                </div>
                                                <div class="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        class="custom-control-input"
                                                        :id="c.id + 'c'"
                                                        v-model="c.status"
                                                        @change="edit_checklist_item(c)"
                                                        :value="c.id"
                                                    />
                                                    <a @click="modalEditChecklist(index)">
                                                        <i
                                                            class="far fa-edit"
                                                            style="padding-right: 50px"
                                                        ></i>
                                                    </a>
                                                    <label
                                                        class="custom-control-label"
                                                        :for="c.id + 'c'"
                                                    ></label>
                                                </div>
                                                <div class="clearfix"></div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Modal Breakdown Melhorado -->
            <BaseModal
                :isVisible="breakdownModal.show"
                title="Edição dos Dados - Tipo de Avaria"
                size="lg"
                @close="closeBreakdownModal"
            >
                <template v-slot:content>
                    <div v-if="selectedBreakdown">
                        <SectionContainer
                            title="Configurações do Tipo de Avaria"
                            icon="car-crash"
                        >
                            <!-- Formulário de edição -->
                            <div class="form-section mt-3">
                                <div class="form-group">
                                    <label
                                        for="breakdownDescription"
                                        class="form-label"
                                    >
                                        <i class="fas fa-edit mr-2"></i>
                                        Descrição do Tipo de Avaria
                                    </label>
                                    <input
                                        type="text"
                                        id="breakdownDescription"
                                        v-model="selectedBreakdown.description"
                                        class="form-control"
                                        placeholder="Digite a descrição do tipo de avaria..."
                                    />
                                </div>
                            </div>

                            <!-- Cards de configuração -->
                            <div class="config-cards-grid">
                                <div class="config-card">
                                    <div class="card-icon">
                                        <i class="fas fa-exclamation-triangle"></i>
                                    </div>
                                    <div class="card-content">
                                        <div class="card-label">Gerar pendência?</div>
                                        <div class="card-description">
                                            Quando marcado, este tipo de avaria gerará uma pendência no sistema
                                        </div>
                                        <div class="switch-container">
                                            <div class="custom-control custom-switch">
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    :id="'divergence_' + selectedBreakdown.id"
                                                    v-model="selectedBreakdown.divergence"
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    :for="'divergence_' + selectedBreakdown.id"
                                                ></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="config-card">
                                    <div class="card-icon">
                                        <i class="fas fa-mobile-alt"></i>
                                    </div>
                                    <div class="card-content">
                                        <div class="card-label">Exibir no APP?</div>
                                        <div class="card-description">
                                            Controla se este tipo aparecerá disponível no aplicativo móvel
                                        </div>
                                        <div class="switch-container">
                                            <div class="custom-control custom-switch">
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    :id="'status_' + selectedBreakdown.id"
                                                    v-model="selectedBreakdown.status"
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    :for="'status_' + selectedBreakdown.id"
                                                ></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Botões de ação -->
                            <div class="action-buttons-section">
                                <button
                                    type="button"
                                    class="btn btn-danger ml-2"
                                    @click="confirmDeleteBreakdown"
                                >
                                    <i class="fas fa-trash-alt mr-2"></i>
                                    Excluir
                                </button>

                                <button
                                    type="button"
                                    class="btn btn-success"
                                    @click="editBreakdownType(selectedBreakdown)"
                                >
                                    <i class="fas fa-save mr-2"></i>
                                    Salvar Alterações
                                </button>

                            </div>
                        </SectionContainer>
                    </div>
                </template>
            </BaseModal>

            <!-- Modal Checklist Melhorado -->
            <BaseModal
                :isVisible="checklistModal.show"
                title="Edição dos Dados - Item de Checklist"
                size="lg"
                @close="closeChecklistModal"
            >
                <template v-slot:content>
                    <div v-if="selectedChecklistItem">
                        <SectionContainer
                            title="Configurações do Item de Checklist"
                            icon="clipboard-check"
                        >
                            <!-- Formulário de edição -->
                            <div class="form-section">
                                <div class="form-group">
                                    <label
                                        for="checklistDescription"
                                        class="form-label"
                                    >
                                        <i class="fas fa-edit mr-2"></i>
                                        Descrição do Item de Checklist
                                    </label>
                                    <input
                                        type="text"
                                        id="checklistDescription"
                                        v-model="selectedChecklistItem.description"
                                        class="form-control"
                                        placeholder="Digite a descrição do item de checklist..."
                                    />
                                </div>
                            </div>

                            <!-- Cards de configuração -->
                            <div class="config-cards-grid">
                                <div class="config-card">
                                    <div class="card-icon">
                                        <i class="fas fa-exclamation-triangle"></i>
                                    </div>
                                    <div class="card-content">
                                        <div class="card-label">Gerar pendência?</div>
                                        <div class="card-description">
                                            Quando marcado, este item gerará uma pendência no sistema
                                        </div>
                                        <div class="switch-container">
                                            <div class="custom-control custom-switch">
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    :id="'div_' + selectedChecklistItem.id"
                                                    v-model="selectedChecklistItem.divergence"
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    :for="'div_' + selectedChecklistItem.id"
                                                ></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="config-card">
                                    <div class="card-icon">
                                        <i class="fas fa-mobile-alt"></i>
                                    </div>
                                    <div class="card-content">
                                        <div class="card-label">Exibir no APP?</div>
                                        <div class="card-description">
                                            Controla se este item aparecerá disponível no aplicativo móvel
                                        </div>
                                        <div class="switch-container">
                                            <div class="custom-control custom-switch">
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    :id="'stat_' + selectedChecklistItem.id"
                                                    v-model="selectedChecklistItem.status"
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    :for="'stat_' + selectedChecklistItem.id"
                                                ></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="config-card">
                                    <div class="card-icon">
                                        <i class="fas fa-asterisk"></i>
                                    </div>
                                    <div class="card-content">
                                        <div class="card-label">Item Obrigatório?</div>
                                        <div class="card-description">
                                            Define se este item é obrigatório no checklist
                                        </div>
                                        <div class="switch-container">
                                            <div class="custom-control custom-switch">
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    :id="'req_' + selectedChecklistItem.id"
                                                    v-model="selectedChecklistItem.required"
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    :for="'req_' + selectedChecklistItem.id"
                                                ></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="config-card">
                                    <div class="card-icon">
                                        <i class="fas fa-comment-alt"></i>
                                    </div>
                                    <div class="card-content">
                                        <div class="card-label">Solicitar justificativa?</div>
                                        <div class="card-description">
                                            Quando marcado, solicitará justificativa do usuário
                                        </div>
                                        <div class="switch-container">
                                            <div class="custom-control custom-switch">
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    :id="'just_' + selectedChecklistItem.id"
                                                    v-model="selectedChecklistItem.justify"
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    :for="'just_' + selectedChecklistItem.id"
                                                ></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Botões de ação -->
                            <div class="action-buttons-section">

                                <button
                                    type="button"
                                    class="btn btn-danger ml-2"
                                    @click="confirmDeleteChecklist"
                                >
                                    <i class="fas fa-trash-alt mr-2"></i>
                                    Excluir
                                </button>

                                <button
                                    type="button"
                                    class="btn btn-success"
                                    @click="edit_checklist_item(selectedChecklistItem)"
                                >
                                    <i class="fas fa-save mr-2"></i>
                                    Salvar Alterações
                                </button>
                            </div>
                        </SectionContainer>
                    </div>
                </template>
            </BaseModal>
        </div>
    </div>
</template>

<script>
import {getMessage} from "../../composables/message";
import BaseModal from "../Base/BaseModal.vue";
import SectionContainer from "../Modals/Checklist/SectionContainer.vue";

export default {
    components: {
        BaseModal,
        SectionContainer
    },
    data() {
        return {
            // Controle dos modais
            breakdownModal: { // breakdownModal - controle do modal de tipo de avaria
                show: false
            },
            checklistModal: { // checklistModal - controle do modal de item de checklist
                show: false
            },

            // Dados selecionados para edição
            selectedBreakdown: null, // selectedBreakdown - tipo de avaria selecionado
            selectedChecklistItem: null, // selectedChecklistItem - item de checklist selecionado

            category: {
                back_photo: true,
                left_side_photo: true,
                right_side_photo: true,
                ceiling_photo: true,
                front_photo: true,
            },
            breakdown_type: {
                description: "",
                checked: "",
            },
            checklist_item: {
                description: "",
                checked: "",
            },
            breakdown_types: [], // breakdown_types - lista de tipos de avaria
            checklist_items: [], // checklist_items - lista de itens de checklist
            checked: [],
            checked_b: [],
            breakdown_items: [],
            index: null,
            indexs: null,
        };
    },
    methods: {
        // closeBreakdownModal - fecha modal de tipo de avaria
        closeBreakdownModal() {
            this.breakdownModal.show = false;
            this.selectedBreakdown = null;
        },

        // closeChecklistModal - fecha modal de item de checklist
        closeChecklistModal() {
            this.checklistModal.show = false;
            this.selectedChecklistItem = null;
        },

        // confirmDeleteBreakdown - confirma exclusão do tipo de avaria
        confirmDeleteBreakdown() {
            if (this.selectedBreakdown) {
                const index = this.breakdown_types.findIndex(b => b.id === this.selectedBreakdown.id);
                if (index !== -1) {
                    this.destroyBreakdownTypes(index);
                }
            }
        },

        // confirmDeleteChecklist - confirma exclusão do item de checklist
        confirmDeleteChecklist() {
            if (this.selectedChecklistItem) {
                const index = this.checklist_items.findIndex(c => c.id === this.selectedChecklistItem.id);
                if (index !== -1) {
                    this.destroyChecklistItems(index);
                }
            }
        },

        makeFormData: function () {
            const self = this;
            let fd = new FormData();

            fd.append("left_side_photo", self.category.left_side_photo ? 1 : 0);
            fd.append("right_side_photo", self.category.right_side_photo ? 1 : 0);
            fd.append("ceiling_photo", self.category.ceiling_photo ? 1 : 0);
            fd.append("front_photo", self.category.front_photo ? 1 : 0);
            fd.append("left_side_photo", self.category.left_side_photo ? 1 : 0);
            fd.append("back_photo", self.category.back_photo ? 1 : 0);
            fd.append("id", 1);
            fd.append("_method", "PUT");

            return fd;
        },
        save: function () {
            const self = this;
            let api = self.$store.state.api + "categories";

            let fd = self.makeFormData();

            if (self.category.id) {
                api += "/" + self.category.id;
            }

            self.$http
                .post(api, fd)
                .then((response) => {
                    self.$message(
                        "Sucesso",
                        `Informações guardadas com sucesso`,
                        "success"
                    );
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        modalEditChecklist(id) {
            this.selectedChecklistItem = {...this.checklist_items[id]};
            this.checklistModal.show = true;
        },

        modalEditBreakdown(id) {
            this.selectedBreakdown = {...this.breakdown_types[id]};
            this.breakdownModal.show = true;
        },
        save_breakdown_type: function () {
            const self = this;
            let api = self.$store.state.api + "breakdownTypes";

            let fd = new FormData();

            fd.append("description", self.breakdown_type.description);

            self.$http
                .post(api, fd)
                .then((response) => {
                    self.$message(
                        "Sucesso",
                        `Informações guardadas com sucesso`,
                        "success"
                    );
                    self.breakdown_type.description = '';
                    self.getBreakdownTypes();
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        editBreakdownType(breakdown) {
            const self = this;
            let api =
                self.$store.state.api + "breakdownTypes/" + breakdown.id;

            let fd = new FormData();

            fd.append("_method", "put");
            fd.append("description", breakdown.description);
            fd.append("status", breakdown.status == false ? 0 : 1);
            fd.append(
                "divergence",
                breakdown.divergence == false ? 0 : 1
            );

            self.$http
                .post(api, fd)
                .then((response) => {
                    self.$message(
                        "Sucesso",
                        `Informações guardadas com sucesso`,
                        "success"
                    );
                    self.closeBreakdownModal();
                    self.getBreakdownTypes();
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        destroyBreakdownTypes(index) {
            const self = this;

            swal({
                title: "Deseja deletar o registro?",
                text: "Essa operação não pode ser desfeita",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, deletar!",
                showLoaderOnConfirm: true,
                buttons: {
                    catch: {
                        text: "Não",
                        value: "cancel",
                        className: "btn-danger",
                    },
                    confirm: {
                        text: "Sim",
                        value: "confirm",
                    },
                },
            }).then((value) => {
                switch (value) {
                    case "cancel":
                        swal("Cancelado", "O registro não foi excluido!", "info");
                        break;

                    case "confirm":
                        const api =
                            self.$store.state.api +
                            "breakdownTypes/" +
                            self.breakdown_types[index].id;

                        self.$http
                            .delete(api)
                            .then((response) => {
                                swal("Sucesso", "Registro excluído com sucesso!", "success");
                                self.closeBreakdownModal();
                                self.getBreakdownTypes();
                            });
                        break;
                }
            });
        },

        save_checklist_item: function () {
            const self = this;
            let api = self.$store.state.api + "checklistItems";

            let fd = new FormData();

            fd.append("description", self.checklist_item.description);
            fd.append("justify", 1);

            self.$http
                .post(api, fd)
                .then((response) => {
                    self.checklist_item.description = '';
                    self.$message(
                        "Sucesso",
                        `Informações guardadas com sucesso`,
                        "success"
                    );
                    self.getChecklistItems();
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        edit_checklist_item(checklist_item) {
            const self = this;
            let api =
                self.$store.state.api + "checklistItems/" + checklist_item.id;

            let fd = new FormData();

            fd.append("_method", "put");
            fd.append("description", checklist_item.description);
            fd.append("status", checklist_item.status == false ? 0 : 1);
            fd.append("required", checklist_item.required == false ? 0 : 1);
            fd.append("justify", checklist_item.justify == false ? 0 : 1);
            fd.append(
                "divergence",
                checklist_item.divergence == false ? 0 : 1
            );

            self.$http
                .post(api, fd)
                .then((response) => {
                    self.$message(
                        "Sucesso",
                        `Informações guardadas com sucesso`,
                        "success"
                    );
                    self.closeChecklistModal();
                    self.getChecklistItems();
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        destroyChecklistItems(index) {
            const self = this;

            swal({
                title: "Deseja deletar o registro?",
                text: "Essa operação não pode ser desfeita",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, deletar!",
                showLoaderOnConfirm: true,
                buttons: {
                    catch: {
                        text: "Não",
                        value: "cancel",
                        className: "btn-danger",
                    },
                    confirm: {
                        text: "Sim",
                        value: "confirm",
                    },
                },
            }).then((value) => {
                switch (value) {
                    case "cancel":
                        swal("Cancelado", "O registro não foi excluido!", "info");
                        break;

                    case "confirm":
                        const api =
                            self.$store.state.api +
                            "checklistItems/" +
                            self.checklist_items[index].id;

                        self.$http
                            .delete(api)
                            .then((response) => {
                                swal("Sucesso", "Registro excluído com sucesso!", "success");
                                self.closeChecklistModal();
                                self.getChecklistItems();
                            });
                        break;
                }
            });
        },
        getCategory: function (id) {
            const self = this;
            const api = self.$store.state.api + "categories/" + id;

            self.$http
                .get(api)
                .then((response) => {
                    self.category = response.data.data[0];
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        getBreakdownTypes: function (id) {
            const self = this;
            const api = self.$store.state.api + "breakdownTypes/";

            self.$http
                .get(api)
                .then((response) => {
                    let breakdown_types = response.data.data;
                    for (let i = 0; i < breakdown_types.length; i++) {
                        breakdown_types[i].checked = false;
                    }
                    self.breakdown_types = breakdown_types;
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        getChecklistItems: function (id) {
            const self = this;
            const api = self.$store.state.api + "checklistItems/";

            self.$http
                .get(api)
                .then((response) => {
                    self.checklist_items = response.data.data;
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
    },
    mounted: function () {
        const self = this;
        self.getBreakdownTypes();
        self.getChecklistItems();
        self.getCategory(1);
    },
};
</script>

<style scoped>
/* Seção do formulário */
.form-section {
    margin-bottom: 25px;
}

.form-label {
    font-weight: 600;
    color: #495057;
    margin-bottom: 8px;
    display: block;
}

.form-control {
    border-radius: 6px;
    border: 1px solid #dee2e6;
    padding: 10px 15px;
    font-size: 14px;
}

.form-control:focus {
    border-color: #f39c12;
    box-shadow: 0 0 0 0.2rem rgba(243, 156, 18, 0.25);
}

/* Grid de cards de configuração */
.config-cards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
    margin: 25px 0;
}

.config-card {
    background-color: white;
    border-radius: 12px;
    padding: 20px;
    border-left: 4px solid #f39c12;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    display: flex;
    align-items: flex-start;
    gap: 15px;
    transition: all 0.3s ease;
}

.config-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.card-icon {
    width: 45px;
    height: 45px;
    background-color: #f39c12;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 5px;
}

.card-icon i {
    color: white;
    font-size: 18px;
}

.card-content {
    flex: 1;
}

.card-label {
    font-size: 16px;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 8px;
}

.card-description {
    font-size: 13px;
    color: #6c757d;
    line-height: 1.4;
    margin-bottom: 15px;
}

.switch-container {
    display: flex;
    align-items: center;
}

.custom-control-label::before {
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
}

.custom-control-input:checked ~ .custom-control-label::before {
    background-color: #f39c12;
    border-color: #f39c12;
}

.custom-control-input:focus ~ .custom-control-label::before {
    box-shadow: 0 0 0 0.2rem rgba(243, 156, 18, 0.25);
}

/* Seção de botões de ação */
.action-buttons-section {
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid #dee2e6;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.btn {
    border-radius: 6px;
    padding: 10px 20px;
    font-weight: 600;
    transition: all 0.3s ease;
}

.btn-success {
    background-color: #28a745;
    border-color: #28a745;
}

.btn-success:hover {
    background-color: #218838;
    border-color: #1e7e34;
    transform: translateY(-1px);
}

.btn-danger {
    background-color: #dc3545;
    border-color: #dc3545;
}

.btn-danger:hover {
    background-color: #c82333;
    border-color: #bd2130;
    transform: translateY(-1px);
}

/* Responsividade */
@media (max-width: 768px) {
    .config-cards-grid {
        grid-template-columns: 1fr;
    }

    .config-card {
        padding: 15px;
    }

    .card-icon {
        width: 40px;
        height: 40px;
    }

    .card-icon i {
        font-size: 16px;
    }

    .action-buttons-section {
        flex-direction: column;
    }

    .action-buttons-section .btn {
        width: 100%;
        margin-left: 0 !important;
        margin-bottom: 10px;
    }
}

@media (max-width: 576px) {
    .config-card {
        flex-direction: column;
        text-align: center;
    }

    .card-icon {
        align-self: center;
        margin-bottom: 10px;
        margin-top: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Category/Add.vue